<template>
  <div class="tabs">
    <ul class="list">
      <li
        class="item"
        v-for="(item, index) in tablist"
        :key="index"
        :class="index == current ? 'active' : ''"
        @click="change(index, item)"
      >
        <span class="label">{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["tabCurrent", "tablist"],
  computed: {
    current() {
      return this.tabCurrent;
    },
  },
  data() {
    return {
      icondefault: require("@/assets/images/time.png"),
    };
  },
  methods: {
    change(index, item) {
      if (item.status) {
        this.$emit("change", index);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tabs {
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  background-color: white;
  padding: 30px;

  .list {
    padding: 0;
    min-height: 60px;
    overflow: hidden;

    .item {
      margin: 0 18px 10px 0;
      padding: 11px 30px;
      display: inline-block;
      color: #333;
      background-color: #f3f4f9;
      border-radius: 100px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;

      &.active {
        color: white !important;
        background-color: #0773fc;
      }

      &:hover {
        background-color: #0773fc;
        color: white;
      }

      .label {
        vertical-align: middle;
        font-weight: 500;
      }
    }
  }
}
</style>
